import React, { useState, useEffect, useCallback } from "react";
import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import CustomTextField from "../../../../components/CustomTextField";
import { searchPayload } from "../../../../utils/common";

const ContactDetail = (props) => {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
    control,
  } = useFormContext();

  const { fields } = props;

  const searchPayloadValue = searchPayload();

  return (
    <Grid container spacing={12} className="row" pt={8}>
      <Grid item md={6}>
        <CustomTextField
          label={t("first_name")}
          name="firstName"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
      <Grid item md={6}>
        <CustomTextField
          label={t("last_name")}
          name="lastName"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
      <Grid item md={6}>
        <CustomTextField
          label={t("email_id")}
          name="emailId"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
      <Grid item md={6}>
        <CustomTextField
          label={t("mobile_number")}
          name="mobileNo"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
    </Grid>
  );
};

export default ContactDetail;
